const EMPTY_RICH_TEXT_PATTERN = /<[^>]*>|&nbsp;|&#160;/gi;
const INVISIBLE_TEXT_PATTERN = /[\u200B-\u200D\uFEFF]/g;

export const hasMeaningfulCommentDraft = (value: unknown): boolean =>
  String(value ?? '')
    .replace(EMPTY_RICH_TEXT_PATTERN, '')
    .replace(INVISIBLE_TEXT_PATTERN, '')
    .trim().length > 0;
